import {createIcon} from '@chakra-ui/react'

export {BoltIcon} from './icons/bolt'
export {DotIcon} from './icons/dot'
export {SensitiveOffIcon} from './icons/SensitiveOffIcon'
export {DeleteIcon} from './icons/DeleteIcon'
export {UploadIcon} from './icons/UploadIcon'
export {
  AttentionIcon,
  AttentionIconWarning,
  AttentionIconAlert,
} from './icons/AttentionIcon'
export {DownloadIcon} from './icons/DownloadIcon'
export {BadgeIcon} from './icons/BadgeIcon'
export {FilterIcon, FilterListIcon} from './icons/FilterListIcon'
export {SwapVerticalIcon} from './icons/SwapVerticalIcon'
export {
  TickedOutlineIcon,
  SmallInverseTickedIcon,
  TickedIcon,
  InverseTickedIcon,
  SolidTickedIcon,
  InverseSolidTickedIcon,
} from './icons/TickedIcon'
export {MarmaladeLogoInCircleIcon} from './icons/MarmaladeLogoInCircleIcon'
export {XeroLogoInCircleIcon} from './icons/XeroLogoInCircleIcon'
export {QuickbooksLogoInCircleIcon} from './icons/QuickbooksLogoInCircleIcon'
export {MyobLogoInCircleIcon} from './icons/MyobLogoInCircleIcon'
export {ShieldTickedIcon} from './icons/ShieldTickedIcon'
export {GiftBoxIcon} from './icons/GiftBoxIcon'
export {PdfIcon} from './icons/PdfIcon'
export {SendIcon} from './icons/SendIcon'
export {MarkUnreadMailboxIcon} from './icons/MarkUnreadMailboxIcon'
export {ArrowDownIcon} from './icons/ArrowDownIcon'
export {HourglassIcon} from './icons/HourglassIcon'
export {OpenInNewIcon} from './icons/OpenInNewIcon'
export {ReceiptLongIcon} from './icons/ReceiptLongIcon'
export {SwitchHorizontalIcon} from './icons/SwitchHorizontalIcon'
export {SupportAgentIcon} from './icons/SupportAgentIcon'
export {PencilWritingIcon} from './icons/PencilWritingIcon'
export {CommentIcon} from './icons/CommentIcon'
export {CogIcon} from './icons/CogIcon'
export {CogWithSparkleIcon} from './icons/CogWithSparkleIcon'
export {PencilIcon} from './icons/PencilIcon'

export const EmptyCircleIcon = createIcon({
  displayName: 'EmptyCircleIcon',
  viewBox: '0 0 16 16',
  path: (
    <path
      d="M8.00016 1.3335C4.3135 1.3335 1.3335 4.3135 1.3335 8.00016C1.3335 11.6868 4.3135 14.6668 8.00016 14.6668C11.6868 14.6668 14.6668 11.6868 14.6668 8.00016C14.6668 4.3135 11.6868 1.3335 8.00016 1.3335ZM8.00016 13.3335C5.0535 13.3335 2.66683 10.9468 2.66683 8.00016C2.66683 5.0535 5.0535 2.66683 8.00016 2.66683C10.9468 2.66683 13.3335 5.0535 13.3335 8.00016C13.3335 10.9468 10.9468 13.3335 8.00016 13.3335Z"
      fill="currentColor"
    />
  ),
})

export const ChecklistIcon = createIcon({
  displayName: 'ChecklistIcon',
  viewBox: '0 0 31 31',
  path: (
    <path
      d="M28.2858 9.68787H16.7144V12.2593H28.2858V9.68787ZM28.2858 19.9736H16.7144V22.545H28.2858V19.9736ZM7.12296 14.8307L2.57153 10.2793L4.38439 8.46644L7.11011 11.1922L12.5615 5.74072L14.3744 7.55358L7.12296 14.8307ZM7.12296 25.1164L2.57153 20.565L4.38439 18.7522L7.11011 21.4779L12.5615 16.0264L14.3744 17.8393L7.12296 25.1164Z"
      fill="currentColor"
    />
  ),
})

export const InsightsIcon = createIcon({
  displayName: 'InsightsIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M21 8.5C19.55 8.5 18.74 9.94 19.07 11.01L15.52 14.57C15.22 14.48 14.78 14.48 14.48 14.57L11.93 12.02C12.27 10.95 11.46 9.5 10 9.5C8.55 9.5 7.73 10.94 8.07 12.02L3.51 16.57C2.44 16.24 1 17.05 1 18.5C1 19.6 1.9 20.5 3 20.5C4.45 20.5 5.26 19.06 4.93 17.99L9.48 13.43C9.78 13.52 10.22 13.52 10.52 13.43L13.07 15.98C12.73 17.05 13.54 18.5 15 18.5C16.45 18.5 17.27 17.06 16.93 15.98L20.49 12.43C21.56 12.76 23 11.95 23 10.5C23 9.4 22.1 8.5 21 8.5Z"
        fill="currentColor"
      />
      <path
        d="M15 9.5L15.94 7.43L18 6.5L15.94 5.57L15 3.5L14.08 5.57L12 6.5L14.08 7.43L15 9.5Z"
        fill="currentColor"
      />
      <path
        d="M3.5 11.5L4 9.5L6 9L4 8.5L3.5 6.5L3 8.5L1 9L3 9.5L3.5 11.5Z"
        fill="currentColor"
      />
    </>
  ),
})

export const RoundedPaidIcon = createIcon({
  displayName: 'RoundedPaidIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.89 11.1C11.11 10.51 10.25 10.14 10.25 9.2C10.25 8.18 11.36 7.81 12.06 7.81C13.37 7.81 13.85 8.8 13.96 9.15L15.54 8.48C15.39 8.04 14.72 6.57 12.88 6.25V5H11.13V6.26C8.53 6.82 8.51 9.11 8.51 9.22C8.51 11.49 10.76 12.13 11.86 12.53C13.44 13.09 14.14 13.6 14.14 14.56C14.14 15.69 13.09 16.17 12.16 16.17C10.34 16.17 9.82 14.3 9.76 14.08L8.1 14.75C8.73 16.94 10.38 17.53 11.12 17.71V19H12.87V17.76C13.39 17.67 15.89 17.17 15.89 14.54C15.9 13.15 15.29 11.93 12.89 11.1Z"
      fill="currentColor"
    />
  ),
})

export const SavingsIcon = createIcon({
  displayName: 'SavingsIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M15 10.5C15 9.95 15.45 9.5 16 9.5C16.55 9.5 17 9.95 17 10.5C17 11.05 16.55 11.5 16 11.5C15.45 11.5 15 11.05 15 10.5ZM8 9.5H13V7.5H8V9.5ZM22 8V14.97L19.18 15.91L17.5 21.5H12V19.5H10V21.5H4.5C4.5 21.5 2 13.04 2 10C2 6.96 4.46 4.5 7.5 4.5H12.5C13.41 3.29 14.86 2.5 16.5 2.5C17.33 2.5 18 3.17 18 4C18 4.21 17.96 4.4 17.88 4.58C17.74 4.92 17.62 5.31 17.56 5.73L19.83 8H22ZM20 10H19L15.5 6.5C15.5 5.85 15.59 5.21 15.76 4.59C14.79 4.84 14 5.56 13.67 6.5H7.5C5.57 6.5 4 8.07 4 10C4 11.88 5.22 16.65 6.01 19.5H8V17.5H14V19.5H16.01L17.56 14.35L20 13.53V10Z"
      fill="currentColor"
    />
  ),
})

export const ArrowRightIcon = createIcon({
  displayName: 'ArrowRightIcon',
  viewBox: '1 4 22 16',
  path: (
    <>
      <path
        d="M2 12L21 12"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M15 5L22 12L15 19"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </>
  ),
})

export const SubdirectoryArrowRightIcon = createIcon({
  displayName: 'SubdirectoryArrowRightIcon',
  viewBox: '0 0 20 20',
  path: (
    <path
      d="M16.25 12.0837L11.25 17.0837L10.0667 15.9003L13.0583 12.917H3.75V2.91699H5.41667V11.2503H13.0583L10.0667 8.26699L11.25 7.08366L16.25 12.0837Z"
      fill="currentColor"
    />
  ),
})

export const AltCheckIcon = createIcon({
  displayName: 'AltCheckIcon',
  viewBox: '0 0 20 20',
  path: (
    <path
      d="M18.3333 4.31699L8.82496 13.8337L5.29163 10.3003L6.46663 9.12533L8.82496 11.4837L17.1583 3.15033L18.3333 4.31699ZM16.4916 8.51699C16.6 8.99199 16.6666 9.49199 16.6666 10.0003C16.6666 13.6837 13.6833 16.667 9.99996 16.667C6.31663 16.667 3.33329 13.6837 3.33329 10.0003C3.33329 6.31699 6.31663 3.33366 9.99996 3.33366C11.3166 3.33366 12.5333 3.71699 13.5666 4.37533L14.7666 3.17533C13.4166 2.22533 11.775 1.66699 9.99996 1.66699C5.39996 1.66699 1.66663 5.40033 1.66663 10.0003C1.66663 14.6003 5.39996 18.3337 9.99996 18.3337C14.6 18.3337 18.3333 14.6003 18.3333 10.0003C18.3333 9.00866 18.15 8.05866 17.8333 7.17533L16.4916 8.51699Z"
      fill="currentColor"
    />
  ),
})

export const SortIcon = createIcon({
  displayName: 'SortIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M1.75 10.5H5.25V9.33333H1.75V10.5ZM1.75 3.5V4.66667H12.25V3.5H1.75ZM1.75 7.58333H8.75V6.41667H1.75V7.58333Z"
      fill="currentColor"
    />
  ),
})

export const GroupByIcon = createIcon({
  displayName: 'GroupByIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M1.75 9.91667V11.0833H5.25V9.91667H1.75ZM1.75 2.91667V4.08333H7.58333V2.91667H1.75ZM7.58333 12.25V11.0833H12.25V9.91667H7.58333V8.75H6.41667V12.25H7.58333ZM4.08333 5.25V6.41667H1.75V7.58333H4.08333V8.75H5.25V5.25H4.08333ZM12.25 7.58333V6.41667H6.41667V7.58333H12.25ZM8.75 5.25H9.91667V4.08333H12.25V2.91667H9.91667V1.75H8.75V5.25Z"
      fill="currentColor"
    />
  ),
})

export const FolderIcon = createIcon({
  displayName: 'FolderIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M7.64199 4.99992L9.30866 6.66659H16.667V14.9999H3.33366V4.99992H7.64199ZM8.33366 3.33325H3.33366C2.41699 3.33325 1.67533 4.08325 1.67533 4.99992L1.66699 14.9999C1.66699 15.9166 2.41699 16.6666 3.33366 16.6666H16.667C17.5837 16.6666 18.3337 15.9166 18.3337 14.9999V6.66659C18.3337 5.74992 17.5837 4.99992 16.667 4.99992H10.0003L8.33366 3.33325Z"
      fill="currentColor"
    />
  ),
})

export const DashboardIcon = createIcon({
  displayName: 'DashboardIcon',
  viewBox: '0 0 22 19',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.38231 3.9681C6.92198 2.73647 8.87499 2 11 2C12.2776 2 13.491 2.26563 14.5897 2.7441L11.4168 8.02872C11.2806 8.00979 11.1414 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14C12.6569 14 14 12.6569 14 11C14 10.2092 13.694 9.4899 13.194 8.95396L16.5957 3.28828C17.0196 2.58228 16.8037 1.61147 16.0098 1.20468C14.5062 0.434239 12.8023 0 11 0C4.92487 0 0 4.92487 0 11C0 13.9977 1.2004 16.7169 3.14447 18.7C3.53109 19.0944 4.16423 19.1007 4.55861 18.7141C4.953 18.3275 4.95929 17.6943 4.57267 17.3C3.19966 15.8994 2.28176 14.0543 2.05487 12H3C3.55228 12 4 11.5523 4 11C4 10.4477 3.55228 10 3 10H2.05493C2.24682 8.26415 2.93238 6.67708 3.9681 5.38232L4.41421 5.82843C4.80474 6.21895 5.4379 6.21895 5.82842 5.82843C6.21895 5.4379 6.21895 4.80474 5.82842 4.41421L5.38231 3.9681ZM19.1615 5.13439C19.6395 4.85785 20.2512 5.02121 20.5278 5.49927C21.4643 7.11825 22 8.99808 22 11C22 13.7976 20.9544 16.3533 19.2341 18.294C18.6455 18.958 17.6571 18.9299 17.0772 18.35L15.7929 17.0657C15.4024 16.6751 15.4024 16.042 15.7929 15.6515C16.1834 15.2609 16.8166 15.2609 17.2071 15.6515L18.0944 16.5387C19.0957 15.2583 19.7573 13.7011 19.9451 12H19C18.4477 12 18 11.5523 18 11C18 10.4477 18.4477 10 19 10H19.9452C19.8055 8.73527 19.4041 7.55093 18.7966 6.50073C18.52 6.02267 18.6834 5.41094 19.1615 5.13439ZM11 12C11.5523 12 12 11.5523 12 11C12 10.4477 11.5523 10 11 10C10.4477 10 10 10.4477 10 11C10 11.5523 10.4477 12 11 12Z"
      fill="currentColor"
    />
  ),
})

export const CashIcon = createIcon({
  displayName: 'CashIcon',
  viewBox: '0 0 24 18',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2V12H3L3 14H0.5C0.223857 14 0 13.7761 0 13.5V0.5C0 0.223857 0.223858 0 0.5 0H19.5C19.7761 0 20 0.223858 20 0.5V3H18V2H2ZM6 10V12C6.52529 12 7.04543 12.1035 7.53073 12.3045C8.01604 12.5055 8.45699 12.8001 8.82843 13.1716C9.19986 13.543 9.4945 13.984 9.69552 14.4693C9.89654 14.9546 10 15.4747 10 16H18C18 15.4747 18.1035 14.9546 18.3045 14.4693C18.5055 13.984 18.8001 13.543 19.1716 13.1716C19.543 12.8001 19.984 12.5055 20.4693 12.3045C20.9546 12.1035 21.4747 12 22 12V10C21.4747 10 20.9546 9.89654 20.4693 9.69552C19.984 9.4945 19.543 9.19986 19.1716 8.82843C18.8001 8.45699 18.5055 8.01604 18.3045 7.53073C18.1035 7.04543 18 6.52529 18 6H10C10 6.52529 9.89654 7.04543 9.69552 7.53073C9.4945 8.01604 9.19986 8.45699 8.82843 8.82843C8.45699 9.19986 8.01604 9.4945 7.53073 9.69552C7.04543 9.89654 6.52529 10 6 10ZM22 14C21.7374 14 21.4773 14.0517 21.2346 14.1522C20.992 14.2528 20.7715 14.4001 20.5858 14.5858C20.4001 14.7715 20.2528 14.992 20.1522 15.2346C20.0517 15.4773 20 15.7374 20 16H22V14ZM22 6V8C21.7374 8 21.4773 7.94827 21.2346 7.84776C20.992 7.74725 20.7715 7.59993 20.5858 7.41421C20.4001 7.2285 20.2528 7.00802 20.1522 6.76537C20.0517 6.52272 20 6.26264 20 6H22ZM6 8C6.26264 8 6.52272 7.94827 6.76537 7.84776C7.00802 7.74725 7.2285 7.59993 7.41421 7.41421C7.59993 7.2285 7.74725 7.00802 7.84776 6.76537C7.94827 6.52272 8 6.26264 8 6H6V8ZM6 16V14C6.26264 14 6.52272 14.0517 6.76537 14.1522C7.00802 14.2528 7.2285 14.4001 7.41421 14.5858C7.59993 14.7715 7.74725 14.992 7.84776 15.2346C7.94827 15.4773 8 15.7374 8 16H6ZM4.5 4C4.22386 4 4 4.22386 4 4.5V17.5C4 17.7761 4.22386 18 4.5 18H23.5C23.7761 18 24 17.7761 24 17.5V4.5C24 4.22386 23.7761 4 23.5 4H4.5ZM14 12C14.5523 12 15 11.5523 15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11C13 11.5523 13.4477 12 14 12ZM14 14C15.6569 14 17 12.6569 17 11C17 9.34315 15.6569 8 14 8C12.3431 8 11 9.34315 11 11C11 12.6569 12.3431 14 14 14Z"
      fill="currentColor"
    />
  ),
})

export const AttachMoneyIcon = createIcon({
  displayName: 'AttachMoneyIcon',
  viewBox: '0 0 32 32',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5015 14.5846C13.583 13.826 12.6444 13.0417 12.6444 11.8203C12.6444 10.4189 13.943 9.44171 16.1158 9.44171C18.4044 9.44171 19.253 10.5346 19.3301 12.1417H22.1715C22.0815 9.93029 20.7315 7.89886 18.0444 7.24314V4.42743H14.1872V7.20457C11.693 7.74457 9.68724 9.36457 9.68724 11.846C9.68724 14.816 12.143 16.2946 15.7301 17.156C18.9444 17.9274 19.5872 19.0589 19.5872 20.2546C19.5872 21.1417 18.9572 22.556 16.1158 22.556C13.4672 22.556 12.4258 21.3731 12.2844 19.856H9.45581C9.6101 22.6717 11.7187 24.2531 14.1872 24.7803V27.5703H18.0444V24.806C20.5515 24.3303 22.5444 22.8774 22.5444 20.2417C22.5444 16.5903 19.4201 15.3431 16.5015 14.5846Z"
      fill="currentColor"
    />
  ),
})

export const UpcomingIcon = createIcon({
  displayName: 'UpcomingIcon',
  viewBox: '0 0 32 32',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.2001 14.4689L21.3872 12.656L25.9644 8.09171L27.7772 9.90457C27.6358 9.94314 23.2001 14.4689 23.2001 14.4689ZM17.2858 4.42743H14.7144V10.856H17.2858V4.42743ZM8.80009 14.4689L10.6129 12.656L6.04866 8.07886L4.22294 9.90457C4.36437 9.94314 8.80009 14.4689 8.80009 14.4689ZM26.2858 18.5703H21.8887C20.8987 20.8331 18.6229 22.4274 16.0001 22.4274C13.3772 22.4274 11.1015 20.8331 10.1115 18.5703H5.71437V24.9989H26.2858V18.5703ZM26.2858 15.9989C27.7001 15.9989 28.8572 17.156 28.8572 18.5703V24.9989C28.8572 26.4131 27.7001 27.5703 26.2858 27.5703H5.71437C4.30009 27.5703 3.14294 26.4131 3.14294 24.9989V18.5703C3.14294 17.156 4.30009 15.9989 5.71437 15.9989H12.1429C12.1429 18.1331 13.8658 19.856 16.0001 19.856C18.1344 19.856 19.8572 18.1331 19.8572 15.9989H26.2858Z"
      fill="currentColor"
    />
  ),
})

export const ReceiptIcon = createIcon({
  displayName: 'ReceiptIcon',
  viewBox: '0 0 32 32',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.643 5.0703L23.7144 3.14172L21.7859 5.0703L19.8573 3.14172L17.9287 5.0703L16.0001 3.14172L14.0716 5.0703L12.143 3.14172L10.2144 5.0703L8.28585 3.14172L6.35728 5.0703L4.42871 3.14172V28.856L6.35728 26.9274L8.28585 28.856L10.2144 26.9274L12.143 28.856L14.0716 26.9274L16.0001 28.856L17.9287 26.9274L19.8573 28.856L21.7859 26.9274L23.7144 28.856L25.643 26.9274L27.5716 28.856V3.14172L25.643 5.0703ZM25.0001 25.1146H7.00014V6.88315H25.0001V25.1146ZM8.28585 19.856H23.7144V22.4274H8.28585V19.856ZM8.28585 14.7132H23.7144V17.2846H8.28585V14.7132ZM8.28585 9.5703H23.7144V12.1417H8.28585V9.5703Z"
      fill="currentColor"
    />
  ),
})

export const InvoicesIcon = createIcon({
  displayName: 'InvoicesIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M19 22V9.41421C19 9.149 18.8946 8.89464 18.7071 8.70711L14.2929 4.29289C14.1054 4.10536 13.851 4 13.5858 4H5C4.44772 4 4 4.44771 4 5V22C4 22.5523 4.44772 23 5 23H18C18.5523 23 19 22.5523 19 22Z"
        stroke="currentColor"
        fill="transparent"
        strokeWidth="2"
      />
      <path
        d="M2 20V20C1.44772 20 1 19.5523 1 19V2C1 1.44771 1.44772 1 2 1H12.5C13.0523 1 13.5 1.44772 13.5 2V2"
        stroke="currentColor"
        fill="transparent"
        strokeWidth="2"
      />
      <path
        d="M14 4V9C14 9.55228 14.4477 10 15 10H19"
        stroke="currentColor"
        fill="transparent"
        strokeWidth="2"
      />
      <path
        d="M7 13.5C7 13.2239 7.22386 13 7.5 13H12.5C12.7761 13 13 13.2239 13 13.5V14.5C13 14.7761 12.7761 15 12.5 15H7.5C7.22386 15 7 14.7761 7 14.5V13.5Z"
        fill="currentColor"
      />
      <path
        d="M7 17.5C7 17.2239 7.22386 17 7.5 17H12.5C12.7761 17 13 17.2239 13 17.5V18.5C13 18.7761 12.7761 19 12.5 19H7.5C7.22386 19 7 18.7761 7 18.5V17.5Z"
        fill="currentColor"
      />
      <rect x="14" y="13" width="2" height="2" rx="0.5" fill="currentColor" />
      <rect x="14" y="17" width="2" height="2" rx="0.5" fill="currentColor" />
    </>
  ),
})

export const HistoryIcon = createIcon({
  displayName: 'HistoryIcon',
  viewBox: '0 0 20 22',
  path: (
    <>
      <path
        d="M10 3C14.9706 3 19 7.02944 19 12C19 16.9706 14.9706 21 10 21C5.02944 21 1 16.9706 1 12C1 9.48234 2.03377 7.20614 3.7 5.57271"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        fill="transparent"
      />
      <path
        d="M10 5.51716V0.482843C10 0.304662 9.78457 0.215428 9.65858 0.341421L7.14142 2.85858C7.06332 2.93668 7.06332 3.06332 7.14142 3.14142L9.65858 5.65858C9.78457 5.78457 10 5.69534 10 5.51716Z"
        fill="currentColor"
      />
      <path
        d="M13.5 8L9.35355 12.1464C9.15829 12.3417 9.15829 12.6583 9.35355 12.8536L11.5 15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        fill="transparent"
      />
    </>
  ),
})

export const StarIcon = createIcon({
  displayName: 'StarIcon',
  viewBox: '0 0 12 12',
  path: (
    <path
      d="M5.04894 0.927049C5.3483 0.00573826 6.6517 0.00573993 6.95106 0.927051L7.5716 2.83688C7.70547 3.2489 8.08943 3.52786 8.52265 3.52786H10.5308C11.4995 3.52786 11.9023 4.76748 11.1186 5.33688L9.49395 6.51722C9.14347 6.77187 8.99681 7.22323 9.13068 7.63525L9.75122 9.54508C10.0506 10.4664 8.9961 11.2325 8.21238 10.6631L6.58778 9.48278C6.2373 9.22813 5.7627 9.22814 5.41221 9.48278L3.78761 10.6631C3.0039 11.2325 1.94942 10.4664 2.24878 9.54508L2.86932 7.63526C3.00319 7.22323 2.85653 6.77186 2.50604 6.51722L0.881445 5.33688C0.0977311 4.76748 0.500508 3.52786 1.46923 3.52786H3.47735C3.91057 3.52786 4.29453 3.2489 4.4284 2.83688L5.04894 0.927049Z"
      fill="currentColor"
    />
  ),
})

export const StampIcon = createIcon({
  displayName: 'StampIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <circle cx="12" cy="4" r="3" stroke="currentColor" strokeWidth="2" />
      <path
        d="M14 6V13C14 14 14.8 16 18 16H21.5C21.7761 16 22 16.2239 22 16.5V22.5C22 22.7761 21.7761 23 21.5 23H2.5C2.22386 23 2 22.7761 2 22.5V16.5C2 16.2239 2.22386 16 2.5 16H6C7.33333 16 10 15.4 10 13V6"
        stroke="currentColor"
        strokeWidth="2"
        fill="transparent"
      />
      <rect x="3" y="19" width="18" height="2" fill="currentColor" />
      <rect x="3" y="15" width="18" height="2" fill="currentColor" />
    </>
  ),
})

export const SettingsCogIcon = createIcon({
  displayName: 'SettingsCogIcon',
  viewBox: '0 0 20 20',
  path: (
    <path
      d="M17.1593 10.98C17.1993 10.66 17.2293 10.34 17.2293 10C17.2293 9.66 17.1993 9.34 17.1593 9.02L19.2693 7.37C19.4593 7.22 19.5093 6.95 19.3893 6.73L17.3893 3.27C17.2993 3.11 17.1293 3.02 16.9493 3.02C16.8893 3.02 16.8293 3.03 16.7793 3.05L14.2893 4.05C13.7693 3.65 13.2093 3.32 12.5993 3.07L12.2193 0.42C12.1893 0.18 11.9793 0 11.7293 0H7.72933C7.47933 0 7.26933 0.18 7.23933 0.42L6.85933 3.07C6.24933 3.32 5.68933 3.66 5.16933 4.05L2.67933 3.05C2.61933 3.03 2.55933 3.02 2.49933 3.02C2.32933 3.02 2.15933 3.11 2.06933 3.27L0.0693316 6.73C-0.0606684 6.95 -0.000668302 7.22 0.189332 7.37L2.29933 9.02C2.25933 9.34 2.22933 9.67 2.22933 10C2.22933 10.33 2.25933 10.66 2.29933 10.98L0.189332 12.63C-0.000668302 12.78 -0.0506684 13.05 0.0693316 13.27L2.06933 16.73C2.15933 16.89 2.32933 16.98 2.50933 16.98C2.56933 16.98 2.62933 16.97 2.67933 16.95L5.16933 15.95C5.68933 16.35 6.24933 16.68 6.85933 16.93L7.23933 19.58C7.26933 19.82 7.47933 20 7.72933 20H11.7293C11.9793 20 12.1893 19.82 12.2193 19.58L12.5993 16.93C13.2093 16.68 13.7693 16.34 14.2893 15.95L16.7793 16.95C16.8393 16.97 16.8993 16.98 16.9593 16.98C17.1293 16.98 17.2993 16.89 17.3893 16.73L19.3893 13.27C19.5093 13.05 19.4593 12.78 19.2693 12.63L17.1593 10.98ZM15.1793 9.27C15.2193 9.58 15.2293 9.79 15.2293 10C15.2293 10.21 15.2093 10.43 15.1793 10.73L15.0393 11.86L15.9293 12.56L17.0093 13.4L16.3093 14.61L15.0393 14.1L13.9993 13.68L13.0993 14.36C12.6693 14.68 12.2593 14.92 11.8493 15.09L10.7893 15.52L10.6293 16.65L10.4293 18H9.02933L8.67933 15.52L7.61933 15.09C7.18933 14.91 6.78933 14.68 6.38933 14.38L5.47933 13.68L4.41933 14.11L3.14933 14.62L2.44933 13.41L3.52933 12.57L4.41933 11.87L4.27933 10.74C4.24933 10.43 4.22933 10.2 4.22933 10C4.22933 9.8 4.24933 9.57 4.27933 9.27L4.41933 8.14L3.52933 7.44L2.44933 6.6L3.14933 5.39L4.41933 5.9L5.45933 6.32L6.35933 5.64C6.78933 5.32 7.19933 5.08 7.60933 4.91L8.66933 4.48L8.82933 3.35L9.02933 2H10.4193L10.7693 4.48L11.8293 4.91C12.2593 5.09 12.6593 5.32 13.0593 5.62L13.9693 6.32L15.0293 5.89L16.2993 5.38L16.9993 6.59L15.9293 7.44L15.0393 8.14L15.1793 9.27ZM9.72933 6C7.51933 6 5.72933 7.79 5.72933 10C5.72933 12.21 7.51933 14 9.72933 14C11.9393 14 13.7293 12.21 13.7293 10C13.7293 7.79 11.9393 6 9.72933 6ZM9.72933 12C8.62933 12 7.72933 11.1 7.72933 10C7.72933 8.9 8.62933 8 9.72933 8C10.8293 8 11.7293 8.9 11.7293 10C11.7293 11.1 10.8293 12 9.72933 12Z"
      fill="black"
    />
  ),
})

export const PaymentSettingsIcon = createIcon({
  displayName: 'PaymentSettingsIcon',
  viewBox: '0 0 23 23',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20V22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11H20C20 6.02944 15.9706 2 11 2ZM17 13.5C17 13.2239 17.2239 13 17.5 13H18.5C18.7762 13 19 13.2239 19 13.5V14.126C19.715 14.31 20.3525 14.6867 20.8541 15.1975L21.3971 14.884C21.6363 14.7459 21.9421 14.8278 22.0801 15.067L22.5801 15.933C22.7182 16.1722 22.6363 16.478 22.3971 16.616L21.855 16.929C21.9495 17.2699 22 17.629 22 18C22 18.371 21.9495 18.7301 21.855 19.071L22.3971 19.384C22.6363 19.522 22.7182 19.8278 22.5801 20.067L22.0801 20.933C21.9421 21.1722 21.6363 21.2541 21.3971 21.116L20.8541 20.8025C20.3525 21.3133 19.715 21.69 19 21.874V22.5C19 22.7761 18.7762 23 18.5 23H17.5C17.2239 23 17 22.7761 17 22.5V21.874C16.2851 21.69 15.6475 21.3133 15.1459 20.8025L14.6029 21.116C14.3638 21.2541 14.058 21.1722 13.9199 20.933L13.4199 20.067C13.2818 19.8278 13.3638 19.522 13.6029 19.384L14.145 19.071C14.0505 18.7301 14 18.371 14 18C14 17.629 14.0505 17.2699 14.145 16.929L13.6029 16.616C13.3638 16.478 13.2818 16.1722 13.4199 15.933L13.9199 15.067C14.058 14.8278 14.3638 14.7459 14.6029 14.884L15.1459 15.1975C15.6475 14.6867 16.2851 14.31 17 14.126V13.5ZM16.2856 19.0305L16.2485 18.9663C16.0901 18.6798 16 18.3504 16 18C16 17.6494 16.0902 17.3199 16.2487 17.0334L16.2854 16.9698C16.6353 16.3887 17.2723 16 18 16C18.7278 16 19.3648 16.3887 19.7147 16.9699L19.7513 17.0333C19.9098 17.3198 20 17.6494 20 18C20 18.3508 19.9097 18.6804 19.7511 18.967L19.7149 19.0298C19.365 19.6111 18.7279 20 18 20C17.2724 20 16.6355 19.6114 16.2856 19.0305ZM13.7503 14.124C14.1983 13.668 14.4223 13.116 14.4223 12.468C14.4223 11.9 14.2823 11.448 14.0023 11.112C13.7303 10.776 13.4023 10.532 13.0183 10.38C12.6423 10.228 12.1583 10.084 11.5663 9.948C11.0143 9.82 10.6103 9.692 10.3543 9.564C10.0983 9.436 9.97034 9.244 9.97034 8.988C9.97034 8.724 10.0823 8.516 10.3063 8.364C10.5303 8.204 10.8223 8.124 11.1823 8.124C11.4303 8.124 11.6623 8.156 11.8783 8.22C12.1023 8.276 12.3103 8.356 12.5023 8.46C12.6943 8.556 12.8183 8.62 12.8743 8.652C13.0423 8.74 13.1703 8.8 13.2583 8.832C13.3463 8.864 13.4383 8.88 13.5343 8.88C13.7263 8.88 13.8943 8.792 14.0383 8.616C14.1823 8.44 14.2543 8.232 14.2543 7.992C14.2543 7.824 14.2223 7.684 14.1583 7.572C14.1023 7.452 14.0023 7.344 13.8583 7.248C13.2263 6.848 12.5783 6.596 11.9143 6.492V5.928C11.9143 5.68 11.8343 5.48 11.6743 5.328C11.5223 5.176 11.3223 5.1 11.0743 5.1C10.8343 5.1 10.6343 5.18 10.4743 5.34C10.3143 5.492 10.2343 5.688 10.2343 5.928V6.528C9.49834 6.68 8.90634 6.992 8.45834 7.464C8.01034 7.936 7.78634 8.492 7.78634 9.132C7.78634 9.692 7.92634 10.14 8.20634 10.476C8.48634 10.804 8.81834 11.048 9.20234 11.208C9.58634 11.36 10.0783 11.512 10.6783 11.664C11.0543 11.76 11.3383 11.84 11.5303 11.904C11.7303 11.968 11.8943 12.056 12.0223 12.168C12.1583 12.272 12.2263 12.408 12.2263 12.576C12.2263 12.856 12.1143 13.068 11.8903 13.212C11.6743 13.348 11.3543 13.416 10.9303 13.416C10.5863 13.416 10.2623 13.376 9.95834 13.296C9.65434 13.216 9.32634 13.08 8.97434 12.888C8.82234 12.8 8.69834 12.74 8.60234 12.708C8.50634 12.676 8.41034 12.66 8.31434 12.66C8.12234 12.66 7.95434 12.748 7.81034 12.924C7.67434 13.1 7.60634 13.308 7.60634 13.548C7.60634 13.732 7.63434 13.88 7.69034 13.992C7.75434 14.104 7.85834 14.204 8.00234 14.292C8.63434 14.7 9.39434 14.96 10.2823 15.072V15.612C10.2823 15.86 10.3583 16.06 10.5103 16.212C10.6703 16.364 10.8743 16.44 11.1223 16.44C11.3703 16.44 11.5703 16.364 11.7223 16.212C11.8823 16.06 11.9623 15.86 11.9623 15.612V15.024C12.7143 14.88 13.3103 14.58 13.7503 14.124Z"
      fill="currentColor"
    />
  ),
})

export const TeamIcon = createIcon({
  displayName: 'TeamIcon',
  viewBox: '0 0 24 20',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 4C18 5.10457 17.1046 6 16 6C14.8954 6 14 5.10457 14 4C14 2.89543 14.8954 2 16 2C17.1046 2 18 2.89543 18 4ZM20 4C20 6.20914 18.2091 8 16 8C13.7909 8 12 6.20914 12 4C12 1.79086 13.7909 0 16 0C18.2091 0 20 1.79086 20 4ZM8 5.5C8 6.32843 7.32843 7 6.5 7C5.67157 7 5 6.32843 5 5.5C5 4.67157 5.67157 4 6.5 4C7.32843 4 8 4.67157 8 5.5ZM10 5.5C10 7.433 8.433 9 6.5 9C4.567 9 3 7.433 3 5.5C3 3.567 4.567 2 6.5 2C8.433 2 10 3.567 10 5.5ZM24 14.332V17C24 18.3565 22.9989 20 21.1429 20H10.8571H2.71429C0.889284 20 0 18.3639 0 17.1429V14.856C0 13.8501 0.389558 12.6369 1.43119 11.8782C3.04092 10.7056 4.94063 10 7 10C8.1612 10 9.27163 10.2243 10.3079 10.6302C12.0096 9.59795 13.9397 9 16 9C18.3623 9 20.5535 9.78611 22.4254 11.1117C23.5518 11.9094 24 13.2128 24 14.332ZM8.58348 12.1826C8.06873 12.0625 7.53969 12 7 12C5.41332 12 3.9187 12.5406 2.60873 13.4948C2.21651 13.7804 2 14.3054 2 14.856V17.1429C2 17.6162 2.3198 18 2.71429 18H8.1711C8.05771 17.6679 8 17.3257 8 17V14.332C8 13.6313 8.17568 12.8584 8.58348 12.1826ZM22 14.332C22 13.6896 21.7402 13.0772 21.2695 12.7439C19.6976 11.6307 17.904 11 16 11C14.096 11 12.3024 11.6307 10.7305 12.7439C10.2598 13.0772 10 13.6896 10 14.332V17C10 17.5523 10.3838 18 10.8571 18H21.1429C21.6162 18 22 17.5523 22 17V14.332Z"
      fill="currentColor"
    />
  ),
})

export const AccountsIcon = createIcon({
  displayName: 'AccountsIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 11C10.3259 11 8.77589 11.4869 7.4584 12.3012C6.41545 12.9458 6 14.0066 6 14.9084V16.3636C6 17.609 7.02764 19 8.78572 19H15.2143C16.9724 19 18 17.609 18 16.3636V14.9084C18 14.0066 17.5846 12.9458 16.5416 12.3012C15.2241 11.4869 13.6741 11 12 11ZM8.50987 14.0025C9.53223 13.3706 10.7211 13 12 13C13.2789 13 14.4678 13.3706 15.4901 14.0025C15.8552 14.2281 16 14.5892 16 14.9084V16.3636C16 16.5981 15.7763 17 15.2143 17H8.78572C8.22368 17 8 16.5981 8 16.3636V14.9084C8 14.5892 8.14484 14.2281 8.50987 14.0025Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10ZM12 8C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="currentColor"
      />
    </>
  ),
})

export const LockIcon = createIcon({
  displayName: 'LockIcon',
  viewBox: '0 0 16 20',
  path: (
    <>
      <rect
        x="1"
        y="9"
        width="14"
        height="10"
        stroke="currentColor"
        strokeWidth="2"
        fill="transparent"
      />
      <path
        d="M13 6V6C13 3.23858 10.7614 1 8 1V1C5.23858 1 3 3.23858 3 6V10"
        stroke="currentColor"
        strokeWidth="2"
        fill="transparent"
      />
      <circle cx="8" cy="14" r="2" fill="currentColor" />
    </>
  ),
})

export const ZoomoutIcon = createIcon({
  displayName: 'ZoomoutIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <circle
        cx="12"
        cy="12"
        r="11"
        stroke="currentColor"
        strokeWidth="2"
        fill="transparent"
      />
      <rect x="7" y="11" width="10" height="2" fill="currentColor" />
    </>
  ),
})

export const CreditCardIcon = createIcon({
  displayName: 'CreditCardIcon',
  viewBox: '0 0 24 18',
  path: (
    <>
      <rect
        x="1"
        y="1"
        width="22"
        height="16"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
        fill="transparent"
      />
      <rect x="1" y="4" width="22" height="4" fill="currentColor" />
    </>
  ),
})

export const BankIcon = createIcon({
  displayName: 'BankIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M12.0537 1.03417L22.7103 7.81563C22.7947 7.86935 22.7566 8 22.6566 8H21V9H3V8H1.34341C1.24336 8 1.20531 7.86935 1.28972 7.81563L11.9463 1.03416C11.9791 1.01332 12.0209 1.01332 12.0537 1.03417Z"
        stroke="currentColor"
        strokeWidth="2"
        fill="transparent"
      />
      <mask id="path-2-inside-1" fill="white">
        <rect x="1" y="19" width="22" height="5" rx="0.2" />
      </mask>
      <rect
        x="1"
        y="19"
        width="22"
        height="5"
        rx="0.2"
        stroke="currentColor"
        strokeWidth="4"
        mask="url(#path-2-inside-1)"
        fill="transparent"
      />
      <rect x="3" y="10" width="2" height="11" fill="currentColor" />
      <rect x="6" y="10" width="2" height="11" fill="currentColor" />
      <rect x="16" y="10" width="2" height="11" fill="currentColor" />
      <rect x="11" y="10" width="2" height="11" fill="currentColor" />
      <rect x="19" y="10" width="2" height="11" fill="currentColor" />
    </>
  ),
})

export const PadlockIcon = createIcon({
  displayName: 'PadlockIcon',
  viewBox: '0 0 18 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 0C5.68629 0 3 2.68629 3 6V8H5V6C5 3.79086 6.79086 2 9 2C11.2091 2 13 3.79086 13 6V8H15V6C15 2.68629 12.3137 0 9 0ZM0 11C0 10.4477 0.447715 10 1 10H17C17.5523 10 18 10.4477 18 11V23C18 23.5523 17.5523 24 17 24H1C0.447716 24 0 23.5523 0 23V11ZM10 17.7324C10.5978 17.3866 11 16.7403 11 16C11 14.8954 10.1046 14 9 14C7.89543 14 7 14.8954 7 16C7 16.7403 7.4022 17.3866 8 17.7324V19.5C8 19.7761 8.22386 20 8.5 20H9.5C9.77614 20 10 19.7761 10 19.5V17.7324Z"
      fill="currentColor"
    />
  ),
})

export const PadlockOutlineIcon = createIcon({
  displayName: 'PadlockOutlineIcon',
  viewBox: '4 2 16 21',
  path: (
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M18 9H17V7C17 4.24 14.76 2 12 2C9.24 2 7 4.24 7 7V9H6C4.9 9 4 9.9 4 11V21C4 22.1 4.9 23 6 23H18C19.1 23 20 22.1 20 21V11C20 9.9 19.1 9 18 9ZM9 7C9 5.34 10.34 4 12 4C13.66 4 15 5.34 15 7V9H9V7ZM18 21H6V11H18V21ZM12 18C13.1 18 14 17.1 14 16C14 14.9 13.1 14 12 14C10.9 14 10 14.9 10 16C10 17.1 10.9 18 12 18Z"
      fill="currentColor"
    />
  ),
})

export const StarTickIcon = createIcon({
  displayName: 'StarTickIcon',
  viewBox: '0 0 17 16',
  path: (
    <path
      fill="currentColor"
      d="M15.9049 8L14.2783 6.14L14.5049 3.68L12.0983 3.13333L10.8383 1L8.57161 1.97333L6.30495 1L5.04495 3.12667L2.63828 3.66667L2.86495 6.13333L1.23828 8L2.86495 9.86L2.63828 12.3267L5.04495 12.8733L6.30495 15L8.57161 14.02L10.8383 14.9933L12.0983 12.8667L14.5049 12.32L14.2783 9.86L15.9049 8ZM7.29828 11.1467L4.76495 8.60667L5.75161 7.62L7.29828 9.17333L11.1983 5.26L12.1849 6.24667L7.29828 11.1467Z"
    />
  ),
})

export const CalendarPaymentIcon = createIcon({
  displayName: 'CalendarPaymentIcon',
  viewBox: '0 0 22 22',
  path: (
    <>
      <rect
        x="1"
        y="3"
        width="20"
        height="18"
        rx="1"
        stroke="currentColor"
        strokeWidth="2"
        fill="transparent"
      />
      <path
        d="M3 0.5C3 0.223858 3.22386 0 3.5 0H4.5C4.77614 0 5 0.223858 5 0.5V4H3V0.5Z"
        fill="currentColor"
      />
      <path
        d="M17 0.5C17 0.223858 17.2239 0 17.5 0H18.5C18.7761 0 19 0.223858 19 0.5V4H17V0.5Z"
        fill="currentColor"
      />
      <path
        d="M14.4224 13.468C14.4224 14.116 14.1984 14.668 13.7504 15.124C13.3104 15.58 12.7144 15.88 11.9624 16.024V16.612C11.9624 16.86 11.8824 17.06 11.7224 17.212C11.5704 17.364 11.3704 17.44 11.1224 17.44C10.8744 17.44 10.6704 17.364 10.5104 17.212C10.3584 17.06 10.2824 16.86 10.2824 16.612V16.072C9.39435 15.96 8.63435 15.7 8.00235 15.292C7.85835 15.204 7.75435 15.104 7.69035 14.992C7.63435 14.88 7.60635 14.732 7.60635 14.548C7.60635 14.308 7.67435 14.1 7.81035 13.924C7.95435 13.748 8.12235 13.66 8.31435 13.66C8.41035 13.66 8.50635 13.676 8.60235 13.708C8.69835 13.74 8.82235 13.8 8.97435 13.888C9.32635 14.08 9.65435 14.216 9.95835 14.296C10.2624 14.376 10.5864 14.416 10.9304 14.416C11.3544 14.416 11.6744 14.348 11.8904 14.212C12.1144 14.068 12.2264 13.856 12.2264 13.576C12.2264 13.408 12.1584 13.272 12.0224 13.168C11.8944 13.056 11.7304 12.968 11.5304 12.904C11.3384 12.84 11.0544 12.76 10.6784 12.664C10.0784 12.512 9.58635 12.36 9.20235 12.208C8.81835 12.048 8.48635 11.804 8.20635 11.476C7.92635 11.14 7.78635 10.692 7.78635 10.132C7.78635 9.492 8.01035 8.936 8.45835 8.464C8.90635 7.992 9.49835 7.68 10.2344 7.528V6.928C10.2344 6.688 10.3144 6.492 10.4744 6.34C10.6344 6.18 10.8344 6.1 11.0744 6.1C11.3224 6.1 11.5224 6.176 11.6744 6.328C11.8344 6.48 11.9144 6.68 11.9144 6.928V7.492C12.5784 7.596 13.2264 7.848 13.8584 8.248C14.0024 8.344 14.1024 8.452 14.1584 8.572C14.2224 8.684 14.2544 8.824 14.2544 8.992C14.2544 9.232 14.1824 9.44 14.0384 9.616C13.8944 9.792 13.7264 9.88 13.5344 9.88C13.4384 9.88 13.3464 9.864 13.2584 9.832C13.1704 9.8 13.0424 9.74 12.8744 9.652C12.8184 9.62 12.6944 9.556 12.5024 9.46C12.3104 9.356 12.1024 9.276 11.8784 9.22C11.6624 9.156 11.4304 9.124 11.1824 9.124C10.8224 9.124 10.5304 9.204 10.3064 9.364C10.0824 9.516 9.97035 9.724 9.97035 9.988C9.97035 10.244 10.0984 10.436 10.3544 10.564C10.6104 10.692 11.0144 10.82 11.5664 10.948C12.1584 11.084 12.6424 11.228 13.0184 11.38C13.4024 11.532 13.7304 11.776 14.0024 12.112C14.2824 12.448 14.4224 12.9 14.4224 13.468Z"
        fill="currentColor"
      />
    </>
  ),
})

export const CheckeredShieldIcon = createIcon({
  displayName: 'CheckeredShieldIcon',
  viewBox: '0 0 18 22',
  path: (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 0L0 4V10C0 15.55 3.84 20.74 9 22C14.16 20.74 18 15.55 18 10V4L9 0ZM9 10.99H16C15.47 15.11 12.72 18.78 9 19.93V11H2V5.3L9 2.19V10.99Z"
        fill="black"
      />
    </svg>
  ),
})

export const WarningIcon = createIcon({
  displayName: 'WarningIcon',
  viewBox: '0 0 24 19',
  path: (
    <>
      <path
        d="M1.18264 18C1.03275 18 0.957933 17.841 1.0299 17.7303L11.8473 1.08189C11.9182 0.972701 12.0818 0.972707 12.1527 1.08189L22.9701 17.7303C23.0421 17.841 22.9673 18 22.8174 18H1.18264Z"
        stroke="currentColor"
        strokeWidth="2"
        fill="transparent"
      />
      <rect x="11" y="7" width="2" height="5" rx="0.5" fill="currentColor" />
      <rect x="11" y="13" width="2" height="2" rx="0.5" fill="currentColor" />
    </>
  ),
})

export const SolidWarningIcon = createIcon({
  displayName: 'SolidWarningIcon',
  viewBox: '0 0 17 12',
  path: (
    <>
      <path
        d="M14.674 12H2.68782C1.8933 12 1.41608 11.1181 1.85069 10.453L7.84377 1.28115C8.23844 0.677152 9.12337 0.677152 9.51803 1.28115L15.5111 10.453C15.9457 11.1181 15.4685 12 14.674 12Z"
        fill="currentColor"
      />
      <path d="M8.68164 4L8.68164 8" stroke="#1B1C22" />
      <path d="M8.68164 9V10" stroke="#1B1C22" />
    </>
  ),
})

export const RoundedColouredMailIcon = createIcon({
  displayName: 'RoundedColouredMailIcon',
  viewBox: '0 0 30 30',
  path: (
    <>
      <circle cx="15" cy="15" r="15" fill="currentColor" />
      <rect
        width="16"
        height="16"
        transform="translate(7 7)"
        fill="currentColor"
      />
      <mask id="path-2-inside-1" fill="white">
        <rect x="7" y="9" width="16" height="12" rx="1" />
      </mask>
      <rect
        x="7"
        y="9"
        width="16"
        height="12"
        rx="1"
        stroke="white"
        strokeWidth="4"
        mask="url(#path-2-inside-1)"
        fill="currentColor"
      />
      <path
        d="M9 11L15 15.5L21.5 11"
        fill="currentColor"
        stroke="white"
        strokeWidth="2"
      />
    </>
  ),
})

export const ClockIcon = createIcon({
  displayName: 'ClockIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.5 7H11V13L16.2 16.2L17 14.9L12.5 12.2V7Z"
      fill="currentColor"
    />
  ),
})

export const WarningOutlineIcon = createIcon({
  displayName: 'WarningOutlineIcon',
  viewBox: '0 0 21 20',
  path: (
    <path
      fill="currentColor"
      d="M9.5 13H11.5V15H9.5V13ZM9.5 5H11.5V11H9.5V5ZM10.49 0C4.97 0 0.5 4.48 0.5 10C0.5 15.52 4.97 20 10.49 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.49 0ZM10.5 18C6.08 18 2.5 14.42 2.5 10C2.5 5.58 6.08 2 10.5 2C14.92 2 18.5 5.58 18.5 10C18.5 14.42 14.92 18 10.5 18Z"
    />
  ),
})

export const RoundedOrangeWarningIcon = createIcon({
  displayName: 'RoundedOrangeWarningIcon',
  viewBox: '0 0 30 30',
  path: (
    <>
      <circle cx="15" cy="15" r="15" fill="#FF9A35" />
      <circle
        cx="15"
        cy="15"
        r="7"
        stroke="white"
        strokeWidth="2"
        fill="#FF9A35"
      />
      <rect
        x="16"
        y="11"
        width="5"
        height="2"
        transform="rotate(90 16 11)"
        fill="white"
      />
      <rect
        x="16"
        y="17"
        width="2"
        height="2"
        transform="rotate(90 16 17)"
        fill="white"
      />
    </>
  ),
})

export const RoundedRedWarningIcon = createIcon({
  displayName: 'RoundedRedWarningIcon',
  viewBox: '0 0 30 30',
  path: (
    <>
      <circle cx="15" cy="15" r="15" fill="#EC4067" />
      <circle
        cx="15"
        cy="15"
        r="7"
        stroke="white"
        strokeWidth="2"
        fill="#EC4067"
      />
      <rect
        x="16"
        y="11"
        width="5"
        height="2"
        transform="rotate(90 16 11)"
        fill="white"
      />
      <rect
        x="16"
        y="17"
        width="2"
        height="2"
        transform="rotate(90 16 17)"
        fill="white"
      />
    </>
  ),
})

export const RoundedColouredEyeIcon = createIcon({
  displayName: 'RoundedColouredEyeIcon',
  viewBox: '0 0 30 30',
  path: (
    <>
      <circle cx="15" cy="15" r="15" fill="currentColor" />
      <path
        d="M15 17C16.1046 17 17 16.1046 17 15C17 13.8954 16.1046 13 15 13C13.8954 13 13 13.8954 13 15C13 16.1046 13.8954 17 15 17Z"
        fill="white"
      />
      <path
        d="M15 10C12.7979 10 11.0731 10.8597 9.90169 11.8667C9.31851 12.368 8.86214 12.9142 8.54482 13.4268C8.2514 13.9008 8 14.4698 8 15C8 15.5144 8.22944 16.0753 8.51471 16.5567C8.82015 17.0721 9.26398 17.6223 9.8415 18.1276C11.0046 19.1453 12.7334 20 15 20C17.2666 20 18.9954 19.1453 20.1585 18.1276C20.736 17.6223 21.1798 17.0721 21.4853 16.5567C21.7706 16.0753 22 15.5144 22 15C22 14.4856 21.7706 13.9247 21.4853 13.4433C21.1798 12.9279 20.736 12.3777 20.1585 11.8724C18.9954 10.8547 17.2666 10 15 10ZM10.0015 15.0049L10.0009 15.0022C10.0009 15.0022 10.0023 14.9976 10.0036 14.9928C10.0152 14.9498 10.0625 14.7749 10.2454 14.4795C10.4504 14.1483 10.7708 13.757 11.2055 13.3833C12.0697 12.6403 13.3449 12 15 12C16.7334 12 18.0046 12.6453 18.8415 13.3776C19.264 13.7473 19.5702 14.1346 19.7647 14.4629C19.9511 14.7774 19.9912 14.9615 19.9985 14.9951L19.9996 15L19.9985 15.0049C19.9912 15.0385 19.9511 15.2226 19.7647 15.5371C19.5702 15.8654 19.264 16.2527 18.8415 16.6224C18.0046 17.3547 16.7334 18 15 18C13.2666 18 11.9954 17.3547 11.1585 16.6224C10.736 16.2527 10.4298 15.8654 10.2353 15.5371C10.0489 15.2226 10.0088 15.0385 10.0015 15.0049Z"
        fill="white"
      />
    </>
  ),
})

export const RoundedColouredCashIcon = createIcon({
  displayName: 'RoundedColouredCashIcon',
  viewBox: '0 0 30 30',
  path: (
    <>
      <circle cx="15" cy="15" r="15" fill="currentColor" />
      <path
        d="M17.0628 17.343C17.3988 17.001 17.5668 16.587 17.5668 16.101C17.5668 15.675 17.4618 15.336 17.2518 15.084C17.0478 14.832 16.8018 14.649 16.5138 14.535C16.2318 14.421 15.8688 14.313 15.4248 14.211C15.0108 14.115 14.7078 14.019 14.5158 13.923C14.3238 13.827 14.2278 13.683 14.2278 13.491C14.2278 13.293 14.3118 13.137 14.4798 13.023C14.6478 12.903 14.8668 12.843 15.1368 12.843C15.3228 12.843 15.4968 12.867 15.6588 12.915C15.8268 12.957 15.9828 13.017 16.1268 13.095C16.2708 13.167 16.3638 13.215 16.4058 13.239C16.5318 13.305 16.6278 13.35 16.6938 13.374C16.7598 13.398 16.8288 13.41 16.9008 13.41C17.0448 13.41 17.1708 13.344 17.2788 13.212C17.3868 13.08 17.4408 12.924 17.4408 12.744C17.4408 12.618 17.4168 12.513 17.3688 12.429C17.3268 12.339 17.2518 12.258 17.1438 12.186C16.6698 11.886 16.1838 11.697 15.6858 11.619V11.196C15.6858 11.01 15.6258 10.86 15.5058 10.746C15.3918 10.632 15.2418 10.575 15.0558 10.575C14.8758 10.575 14.7258 10.635 14.6058 10.755C14.4858 10.869 14.4258 11.016 14.4258 11.196V11.646C13.8738 11.76 13.4298 11.994 13.0938 12.348C12.7578 12.702 12.5898 13.119 12.5898 13.599C12.5898 14.019 12.6948 14.355 12.9048 14.607C13.1148 14.853 13.3638 15.036 13.6518 15.156C13.9398 15.27 14.3088 15.384 14.7588 15.498C15.0408 15.57 15.2538 15.63 15.3978 15.678C15.5478 15.726 15.6708 15.792 15.7668 15.876C15.8688 15.954 15.9198 16.056 15.9198 16.182C15.9198 16.392 15.8358 16.551 15.6678 16.659C15.5058 16.761 15.2658 16.812 14.9478 16.812C14.6898 16.812 14.4468 16.782 14.2188 16.722C13.9908 16.662 13.7448 16.56 13.4808 16.416C13.3668 16.35 13.2738 16.305 13.2018 16.281C13.1298 16.257 13.0578 16.245 12.9858 16.245C12.8418 16.245 12.7158 16.311 12.6078 16.443C12.5058 16.575 12.4548 16.731 12.4548 16.911C12.4548 17.049 12.4758 17.16 12.5178 17.244C12.5658 17.328 12.6438 17.403 12.7518 17.469C13.2258 17.775 13.7958 17.97 14.4618 18.054V18.459C14.4618 18.645 14.5188 18.795 14.6328 18.909C14.7528 19.023 14.9058 19.08 15.0918 19.08C15.2778 19.08 15.4278 19.023 15.5418 18.909C15.6618 18.795 15.7218 18.645 15.7218 18.459V18.018C16.2858 17.91 16.7328 17.685 17.0628 17.343Z"
        fill="white"
      />
      <path
        d="M23 15C23 19.4183 19.4183 23 15 23C10.5817 23 7 19.4183 7 15C7 10.5817 10.5817 7 15 7C19.4183 7 23 10.5817 23 15ZM21 15C21 11.6863 18.3137 9 15 9C11.6863 9 9 11.6863 9 15C9 18.3137 11.6863 21 15 21C18.3137 21 21 18.3137 21 15Z"
        fill="white"
      />
    </>
  ),
})

export const VerticalLineIcon = createIcon({
  displayName: 'VerticalLineIcon',
  viewBox: '0 0 2 50',
  path: (
    <line
      x1="1"
      y1="-4.37114e-08"
      x2="1"
      y2="50"
      stroke="currentColor"
      strokeWidth="2"
    />
  ),
})
export const TriangleUpIcon = createIcon({
  displayName: 'TriangleUpIcon',
  viewBox: '0 0 14 9',
  path: <path d="M0 9L14 9L7.25 -5.90104e-07L0 9Z" fill="currentColor" />,
})

export const LogoutIcon = createIcon({
  displayName: 'LogoutIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M17 8L15.59 9.41L17.17 11H9V13H17.17L15.59 14.58L17 16L21 12L17 8ZM5 5H12V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H12V19H5V5Z"
      fill="currentColor"
    />
  ),
})

export const PaidIcon = createIcon({
  displayName: 'PaidIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12.88,17.76V19h-1.75v-1.29 c-0.74-0.18-2.39-0.77-3.02-2.96l1.65-0.67c0.06,0.22,0.58,2.09,2.4,2.09c0.93,0,1.98-0.48,1.98-1.61c0-0.96-0.7-1.46-2.28-2.03 c-1.1-0.39-3.35-1.03-3.35-3.31c0-0.1,0.01-2.4,2.62-2.96V5h1.75v1.24c1.84,0.32,2.51,1.79,2.66,2.23l-1.58,0.67 c-0.11-0.35-0.59-1.34-1.9-1.34c-0.7,0-1.81,0.37-1.81,1.39c0,0.95,0.86,1.31,2.64,1.9c2.4,0.83,3.01,2.05,3.01,3.45 C15.9,17.17,13.4,17.67,12.88,17.76z"
      fill="currentColor"
    />
  ),
})

export const FlagIcon = createIcon({
  displayName: 'flagIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M11.86 5.5L12.26 7.5H17.5V13.5H14.14L13.74 11.5H6.5V5.5H11.86ZM13.5 3.5H4.5V20.5H6.5V13.5H12.1L12.5 15.5H19.5V5.5H13.9L13.5 3.5Z"
      fill="currentColor"
    />
  ),
})

export const ShieldIcon = createIcon({
  displayName: 'shieldIcon',
  viewBox: '0 0 16 20',
  path: (
    <path
      d="M8.5 0L0.5 3V9.09C0.5 14.14 3.91 18.85 8.5 20C13.09 18.85 16.5 14.14 16.5 9.09V3L8.5 0ZM14.5 9.09C14.5 13.09 11.95 16.79 8.5 17.92C5.05 16.79 2.5 13.1 2.5 9.09V4.39L8.5 2.14L14.5 4.39V9.09Z"
      fill="currentColor"
    />
  ),
})

export const PersonIcon = createIcon({
  displayName: 'personIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM5.57 16.28C6 15.38 8.62 14.5 10.5 14.5C12.38 14.5 15.01 15.38 15.43 16.28C14.07 17.36 12.36 18 10.5 18C8.64 18 6.93 17.36 5.57 16.28ZM16.86 14.83C15.43 13.09 11.96 12.5 10.5 12.5C9.04 12.5 5.57 13.09 4.14 14.83C3.12 13.49 2.5 11.82 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 11.82 17.88 13.49 16.86 14.83ZM10.5 4C8.56 4 7 5.56 7 7.5C7 9.44 8.56 11 10.5 11C12.44 11 14 9.44 14 7.5C14 5.56 12.44 4 10.5 4ZM10.5 9C9.67 9 9 8.33 9 7.5C9 6.67 9.67 6 10.5 6C11.33 6 12 6.67 12 7.5C12 8.33 11.33 9 10.5 9Z"
      fill="currentColor"
    />
  ),
})

export const PeopleIcon = createIcon({
  displayName: 'peopleIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z"
      fill="white"
    />
  ),
})

export const SparkleGraphIcon = createIcon({
  displayName: 'sparkleGraphIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M20.5 5.5C19.05 5.5 18.24 6.94 18.57 8.01L15.02 11.57C14.72 11.48 14.28 11.48 13.98 11.57L11.43 9.02C11.77 7.95 10.96 6.5 9.5 6.5C8.05 6.5 7.23 7.94 7.57 9.02L3.01 13.57C1.94 13.24 0.5 14.05 0.5 15.5C0.5 16.6 1.4 17.5 2.5 17.5C3.95 17.5 4.76 16.06 4.43 14.99L8.98 10.43C9.28 10.52 9.72 10.52 10.02 10.43L12.57 12.98C12.23 14.05 13.04 15.5 14.5 15.5C15.95 15.5 16.77 14.06 16.43 12.98L19.99 9.43C21.06 9.76 22.5 8.95 22.5 7.5C22.5 6.4 21.6 5.5 20.5 5.5Z"
        fill="currentColor"
      />
      <path
        d="M14.5 6.5L15.44 4.43L17.5 3.5L15.44 2.57L14.5 0.5L13.58 2.57L11.5 3.5L13.58 4.43L14.5 6.5Z"
        fill="currentColor"
      />
      <path
        d="M3 8.5L3.5 6.5L5.5 6L3.5 5.5L3 3.5L2.5 5.5L0.5 6L2.5 6.5L3 8.5Z"
        fill="currentColor"
      />
    </>
  ),
})

export const NotConnectedIcon = createIcon({
  displayName: 'NotConnectedIcon',
  viewBox: '0 0 12 14',
  path: (
    <path
      fill="currentColor"
      d="M10.1933 8.32699V4.66699C10.1933 4.00033 9.52 3.32699 8.86 3.33366V0.666992H7.52667V3.33366H4.86V0.666992H3.52667V2.32033L9.86667 8.65366L10.1933 8.32699ZM9.02 9.50699L2.99333 3.46699L2.98667 3.47366L0.846667 1.33366L0 2.16699L2.24 4.40699C2.22 4.49366 2.19333 4.58033 2.19333 4.66699V8.32032L4.52667 10.667V12.667H7.86V10.667L8.18 10.347L11.16 13.3337L12 12.4803L9.02 9.50699Z"
    />
  ),
})

export const PaperClipIcon = createIcon({
  displayName: 'PaperClipIcon',
  viewBox: '0 0 20 20',
  path: (
    <path
      d="M14.375 12H5.75C4.0925 12 2.75 10.6575 2.75 9C2.75 7.3425 4.0925 6 5.75 6H15.125C16.16 6 17 6.84 17 7.875C17 8.91 16.16 9.75 15.125 9.75H7.25C6.8375 9.75 6.5 9.4125 6.5 9C6.5 8.5875 6.8375 8.25 7.25 8.25H14.375V7.125H7.25C6.215 7.125 5.375 7.965 5.375 9C5.375 10.035 6.215 10.875 7.25 10.875H15.125C16.7825 10.875 18.125 9.5325 18.125 7.875C18.125 6.2175 16.7825 4.875 15.125 4.875H5.75C3.47 4.875 1.625 6.72 1.625 9C1.625 11.28 3.47 13.125 5.75 13.125H14.375V12Z"
      fill="currentColor"
    />
  ),
})

export const HomeIcon = createIcon({
  displayName: 'MarmaladeHomeIcon',
  viewBox: '0 0 21 22',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 16.1258V8.71137L10 2.52759L2 8.71137V19.9998H15C15 20.7283 15.1948 21.4114 15.5351 21.9998H1C0.447715 21.9998 0 21.552 0 20.9998V7.72948L9.38843 0.472481C9.74861 0.194069 10.2514 0.194069 10.6116 0.472481L20 7.72948V16.1258C19.6804 16.0435 19.3453 15.9998 19 15.9998C18.6547 15.9998 18.3196 16.0435 18 16.1258Z"
        fill="currentColor"
      />
      <ellipse
        cx="2"
        cy="2"
        rx="2"
        ry="2"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 17 22)"
        fill="currentColor"
      />
    </>
  ),
})

export const DocumentIcon = createIcon({
  displayName: 'MarmaladeDocumentIcon',
  viewBox: '0 0 21 22',
  path: (
    <>
      <rect
        x="9.5"
        y="9.5"
        width="5"
        height="1"
        fill="transparent"
        stroke="currentColor"
      />
      <rect
        x="9.5"
        y="13.5"
        width="5"
        height="1"
        fill="transparent"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 1H3V2V21C3 22.1046 3.89543 23 5 23H16.3542C15.7638 22.4789 15.3284 21.7862 15.126 21H5V3H5.01395H5.04695H5.07989H5.11278H5.14563H5.17842H5.21117H5.24387H5.27652H5.30912H5.34167H5.37418H5.40664H5.43905H5.47141H5.50373H5.536H5.56822H5.6004H5.63253H5.66461H5.69665H5.72864H5.76059H5.79249H5.82435H5.85616H5.88793H5.91965H5.95133H5.98297H6.01456H6.04611H6.07762H6.10908H6.1405H6.17187H6.20321H6.2345H6.26575H6.29696H6.32812H6.35925H6.39033H6.42138H6.45238H6.48334H6.51426H6.54514H6.57598H6.60678H6.63754H6.66827H6.69895H6.72959H6.7602H6.79076H6.82129H6.85178H6.88224H6.91265H6.94303H6.97337H7.00367H7.03394H7.06417H7.09436H7.12451H7.15464H7.18472H7.21477H7.24478H7.27476H7.30471H7.33461H7.36449H7.39433H7.42413H7.45391H7.48364H7.51335H7.54302H7.57266H7.60226H7.63183H7.66137H7.69088H7.72036H7.7498H7.77921H7.80859H7.83794H7.86726H7.89655H7.9258H7.95503H7.98422H8.01339H8.04253H8.07163H8.10071H8.12976H8.15877H8.18776H8.21673H8.24566H8.27456H8.30344H8.33229H8.36111H8.38991H8.41867H8.44741H8.47613H8.50481H8.53347H8.56211H8.59072H8.6193H8.64786H8.67639H8.7049H8.73338H8.76184H8.79027H8.81868H8.84707H8.87543H8.90377H8.93208H8.96037H8.98864H9.01689H9.04511H9.07331H9.10149H9.12964H9.15778H9.18589H9.21398H9.24206H9.27011H9.29813H9.32614H9.35413H9.3821H9.41005H9.43798H9.46589H9.49378H9.52165H9.5495H9.57733H9.60515H9.63295H9.66073H9.68849H9.71623H9.74396H9.77167H9.79936H9.82703H9.85469H9.88234H9.90996H9.93757H9.96517H9.99275H10.0203H10.0479H10.0754H10.1029H10.1304H10.1579H10.1854H10.2128H10.2403H10.2677H10.2952H10.3226H10.35H10.3773H10.4047H10.4321H10.4594H10.4868H10.5141H10.5414H10.5687H10.596H10.6233H10.6505H10.6778H10.705H10.7323H10.7595H10.7867H10.8139H10.8411H10.8683H10.8955H10.9227H10.9499H10.977H11.0042H11.0313H11.0585H11.0856H11.1127H11.1398H11.1669H11.194H11.2211H11.2482H11.2753H11.3024H11.3295H11.3565H11.3836H11.4106H11.4377H11.4647H11.4918H11.5188H11.5459H11.5729H11.5999H11.627H11.654H11.681H11.708H11.735H11.7621H11.7891H11.8161H11.8431H11.8701H11.8971H11.9241H11.9511H11.9781H12.0051H12.0322H12.0592H12.0862H12.1132H12.1402H12.1672H12.1942H12.2212H12.2482H12.2753H12.3023H12.3293H12.3563H12.3833H12.4104H12.4374H12.4644H12.4915H12.5185H12.5456H12.5726H12.5997H12.6267H12.6538H12.6809H12.7079H12.735H12.7621H12.7892H12.8163H12.8434H12.8705H12.8976H12.9248H12.9519H12.979H13.0062H13.0333H13.0605H13.0877H13.1148H13.142H13.1692H13.1964H13.2236H13.2509H13.2781H13.3053H13.3326H13.3599H13.3871H13.4144H13.4417H13.469H13.4963H13.5237H13.551H13.5784H13.6057H13.6331H13.6605H13.6879H13.7153H13.7427H13.7702H13.7976H13.8251H13.8526H13.8801H13.9076H13.9351H13.9626H13.9902H14.0178H14.0454H14.073H14.1006H14.1282H14.1559H14.1835H14.2112H14.2389H14.2666H14.2943H14.3221H14.3499H14.3777H14.4055H14.4333H14.4611H14.489H14.5169H14.5448H14.5727H14.6006H14.6286H14.6565H14.6845H14.7126H14.7406H14.7686H14.7967H14.8248H14.8529H14.8811H14.9093H14.9374H14.9657H14.9939H15.0221H15.0504H15.0787H15.107H15.1354H15.1638H15.1921H15.2206H15.249H15.2775H15.306H15.3345H15.363H15.3916H15.4202H15.4488H15.4775H15.5061H15.5348H15.5635H15.5923H15.6211H15.6499H15.6787H15.7076H15.7365H15.7654H15.7943H15.8233H15.8523H15.8813H15.9104H15.9395H15.9686H15.9977H16.0269H16.0561H16.0854H16.1146H16.1439H16.1732H16.2026H16.232H16.2614H16.2909H16.3204H16.3499H16.3794H16.409H16.4386H16.4683H16.498H16.5277H16.5574H16.5872H16.617H16.6469H16.6768H16.7067H16.7367H16.7667H16.7967H16.8267H16.8568H16.887H16.9172H16.9474H16.9776H17.0079H17.0382H17.0686H17.0989H17.1294H17.1598H17.1903H17.2209H17.2515H17.2821H17.3127H17.3434H17.3742H17.405H17.4358H17.4666H17.4975H17.5285H17.5594H17.5905H17.6215H17.6526H17.6838H17.7149H17.7462H17.7774H17.8087H17.8401H17.8715H17.9029H17.9344H17.9659H17.9975H18.0291H18.0607H18.0924H18.1242H18.156H18.1878H18.2197H18.2516H18.2836H18.3156H18.3476H18.3797H18.4119H18.4441H18.4763H18.5086H18.5409H18.5733H18.6057H18.6382H18.6707H18.7033H18.7359H18.7686H18.8013H18.8341H18.8669H18.8998H18.9327H18.9656H18.9986L18.9992 3.00001L19 3.00066L19 3.00068V16C19.7286 16 20.4117 16.1948 21 16.5351V3C21 1.89366 20.1014 1 18.9986 1H18.9656H18.9327H18.8998H18.8669H18.8341H18.8013H18.7686H18.7359H18.7033H18.6707H18.6382H18.6057H18.5733H18.5409H18.5086H18.4763H18.4441H18.4119H18.3797H18.3476H18.3156H18.2836H18.2516H18.2197H18.1878H18.156H18.1242H18.0924H18.0607H18.0291H17.9975H17.9659H17.9344H17.9029H17.8715H17.8401H17.8087H17.7774H17.7462H17.7149H17.6838H17.6526H17.6215H17.5905H17.5594H17.5285H17.4975H17.4666H17.4358H17.405H17.3742H17.3434H17.3127H17.2821H17.2515H17.2209H17.1903H17.1598H17.1294H17.0989H17.0686H17.0382H17.0079H16.9776H16.9474H16.9172H16.887H16.8568H16.8267H16.7967H16.7667H16.7367H16.7067H16.6768H16.6469H16.617H16.5872H16.5574H16.5277H16.498H16.4683H16.4386H16.409H16.3794H16.3499H16.3204H16.2909H16.2614H16.232H16.2026H16.1732H16.1439H16.1146H16.0854H16.0561H16.0269H15.9977H15.9686H15.9395H15.9104H15.8813H15.8523H15.8233H15.7943H15.7654H15.7365H15.7076H15.6787H15.6499H15.6211H15.5923H15.5635H15.5348H15.5061H15.4775H15.4488H15.4202H15.3916H15.363H15.3345H15.306H15.2775H15.249H15.2206H15.1921H15.1638H15.1354H15.107H15.0787H15.0504H15.0221H14.9939H14.9657H14.9374H14.9093H14.8811H14.8529H14.8248H14.7967H14.7686H14.7406H14.7126H14.6845H14.6565H14.6286H14.6006H14.5727H14.5448H14.5169H14.489H14.4611H14.4333H14.4055H14.3777H14.3499H14.3221H14.2943H14.2666H14.2389H14.2112H14.1835H14.1559H14.1282H14.1006H14.073H14.0454H14.0178H13.9902H13.9626H13.9351H13.9076H13.8801H13.8526H13.8251H13.7976H13.7702H13.7427H13.7153H13.6879H13.6605H13.6331H13.6057H13.5784H13.551H13.5237H13.4963H13.469H13.4417H13.4144H13.3871H13.3599H13.3326H13.3053H13.2781H13.2509H13.2236H13.1964H13.1692H13.142H13.1148H13.0877H13.0605H13.0333H13.0062H12.979H12.9519H12.9248H12.8976H12.8705H12.8434H12.8163H12.7892H12.7621H12.735H12.7079H12.6809H12.6538H12.6267H12.5997H12.5726H12.5456H12.5185H12.4915H12.4644H12.4374H12.4104H12.3833H12.3563H12.3293H12.3023H12.2753H12.2482H12.2212H12.1942H12.1672H12.1402H12.1132H12.0862H12.0592H12.0322H12.0051H11.9781H11.9511H11.9241H11.8971H11.8701H11.8431H11.8161H11.7891H11.7621H11.735H11.708H11.681H11.654H11.627H11.5999H11.5729H11.5459H11.5188H11.4918H11.4647H11.4377H11.4106H11.3836H11.3565H11.3295H11.3024H11.2753H11.2482H11.2211H11.194H11.1669H11.1398H11.1127H11.0856H11.0585H11.0313H11.0042H10.977H10.9499H10.9227H10.8955H10.8683H10.8411H10.8139H10.7867H10.7595H10.7323H10.705H10.6778H10.6505H10.6233H10.596H10.5687H10.5414H10.5141H10.4868H10.4594H10.4321H10.4047H10.3773H10.35H10.3226H10.2952H10.2677H10.2403H10.2128H10.1854H10.1579H10.1304H10.1029H10.0754H10.0479H10.0203H9.99275H9.96517H9.93757H9.90996H9.88234H9.85469H9.82703H9.79936H9.77167H9.74396H9.71623H9.68849H9.66073H9.63295H9.60515H9.57733H9.5495H9.52165H9.49378H9.46589H9.43798H9.41005H9.3821H9.35413H9.32614H9.29813H9.27011H9.24206H9.21398H9.18589H9.15778H9.12964H9.10149H9.07331H9.04511H9.01689H8.98864H8.96037H8.93208H8.90377H8.87543H8.84707H8.81868H8.79027H8.76184H8.73338H8.7049H8.67639H8.64786H8.6193H8.59072H8.56211H8.53347H8.50481H8.47613H8.44741H8.41867H8.38991H8.36111H8.33229H8.30344H8.27456H8.24566H8.21673H8.18776H8.15877H8.12976H8.10071H8.07163H8.04253H8.01339H7.98422H7.95503H7.9258H7.89655H7.86726H7.83794H7.80859H7.77921H7.7498H7.72036H7.69088H7.66137H7.63183H7.60226H7.57266H7.54302H7.51335H7.48364H7.45391H7.42413H7.39433H7.36449H7.33461H7.30471H7.27476H7.24478H7.21477H7.18472H7.15464H7.12451H7.09436H7.06417H7.03394H7.00367H6.97337H6.94303H6.91265H6.88224H6.85178H6.82129H6.79076H6.7602H6.72959H6.69895H6.66827H6.63754H6.60678H6.57598H6.54514H6.51426H6.48334H6.45238H6.42138H6.39033H6.35925H6.32812H6.29696H6.26575H6.2345H6.20321H6.17187H6.1405H6.10908H6.07762H6.04611H6.01456H5.98297H5.95133H5.91965H5.88793H5.85616H5.82435H5.79249H5.76059H5.72864H5.69665H5.66461H5.63253H5.6004H5.56822H5.536H5.50373H5.47141H5.43905H5.40664H5.37418H5.34167H5.30912H5.27652H5.24387H5.21117H5.17842H5.14563H5.11278H5.07989H5.04695H5.01395H4.98091H4.94782H4.91467H4.88148H4.84823H4.81494H4.78159H4.74819H4.71474H4.68124H4.64768H4.61408H4.58042H4.54671H4.51294H4.47913H4.44526H4.41133H4.37735H4.34332H4.30924H4.2751H4.2409H4.20665H4.17235H4.13799H4.10358H4.06911H4.03458H4Z"
        fill="currentColor"
      />
      <ellipse
        cx="2"
        cy="2"
        rx="2"
        ry="2"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 17 22)"
        fill="currentColor"
      />
    </>
  ),
})

export const CoinCashInIcon = createIcon({
  displayName: 'MarmaladeCashIcon',
  viewBox: '0 0 21 22',
  path: (
    <>
      <ellipse
        cx="2"
        cy="2"
        rx="2"
        ry="2"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 10)"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.92338 8.02778C8.92338 9.18889 9.78389 9.93444 12.4597 10.6556C15.1356 11.3767 18 12.5622 18 16.0333C18 18.5389 16.1729 19.92 13.8743 20.3722V23H10.3379V20.3478C8.07466 19.8467 6.14145 18.3433 6 15.6667H8.59332C8.72299 17.1089 9.6778 18.2333 12.1061 18.2333C14.7112 18.2333 15.2888 16.8889 15.2888 16.0456C15.2888 14.9089 14.6994 13.8333 11.7525 13.1C8.46365 12.2811 6.21218 10.8756 6.21218 8.05222C6.21218 5.69333 8.05108 4.15333 10.3379 3.64V1H13.8743V3.67667C14.6549 3.87417 15.3124 4.20297 15.8491 4.62691C15.1684 5.06192 14.628 5.69735 14.3114 6.45003C13.8451 6.01601 13.134 5.76667 12.1061 5.76667C10.1139 5.76667 8.92338 6.69556 8.92338 8.02778Z"
        fill="currentColor"
      />
    </>
  ),
})

export const CustomerIcon = createIcon({
  displayName: 'CustomerIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <circle
        cx="11"
        cy="7"
        r="5"
        stroke="currentColor"
        strokeWidth="2"
        fill="transparent"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 23C4 21.3596 4.90822 19.6118 6.43199 18.2442C7.94782 16.8838 9.96715 16 12 16C14.0329 16 16.0522 16.8838 17.568 18.2442C17.6686 18.3345 17.7664 18.4264 17.8616 18.5198C18.2822 17.9882 18.8351 17.566 19.4705 17.3028C19.2885 17.1137 19.0993 16.9312 18.9039 16.7558C17.077 15.1162 14.5963 14 12 14C9.40369 14 6.92302 15.1162 5.09614 16.7558C3.2772 18.3882 2 20.6404 2 23H4Z"
        fill="currentColor"
      />
      <ellipse
        cx="2"
        cy="2"
        rx="2"
        ry="2"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 19 23)"
        fill="currentColor"
      />
    </>
  ),
})

export const WalletIcon = createIcon({
  displayName: 'WalletIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <ellipse
        cx="2"
        cy="2"
        rx="2"
        ry="2"
        transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 19 21)"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.00004 5.71416V5.71429L1 6.68248L1.00004 7.42858L1.00005 7.4334L1.0001 13.9463L1.00014 17.1263L1.00015 18.0616L1.00016 18.3129L1.00016 18.3779L1.00016 18.3945L1.00016 18.3986L1.00016 18.3997V18.3999L2.00016 18.4H1.00016C1.00016 19.1177 1.31083 19.7874 1.83248 20.2673C2.35133 20.7446 3.03848 21 3.73928 21H17.5352C17.1948 20.4117 17 19.7286 17 19H3.73928C3.5176 19 3.32004 18.9182 3.18659 18.7954C3.05595 18.6752 3.00016 18.5309 3.00016 18.4V18.4L2.00016 18.4L3.00016 18.3999V18.3996V18.3986V18.3944L3.00016 18.3779L3.00016 18.3129L3.00015 18.0615L3.00014 17.1263L3.0001 13.9463L3.00006 8.42857L4.43664 8.42857L10.1643 8.42857L21 8.42857V15C21.7286 15 22.4117 15.1948 23 15.5351V7.42857C23 6.87629 22.5523 6.42857 22 6.42857L10.1643 6.42857L4.43664 6.42857L3.00004 6.42857L3.00004 5.73376L3.00012 5.73289C3.00128 5.72039 3.00444 5.69362 3.01221 5.65766C3.02838 5.58287 3.05988 5.48919 3.117 5.40106C3.192 5.28536 3.41477 5 4.22225 5H4.23539H4.24874H4.26233H4.27613H4.29015H4.3044H4.31887H4.33355H4.34845H4.36357H4.37891H4.39445H4.41022H4.42619H4.44238H4.45878H4.47539H4.49221H4.50923H4.52646H4.5439H4.56154H4.57939H4.59744H4.61569H4.63415H4.6528H4.67165H4.6907H4.70995H4.7294H4.74904H4.76887H4.7889H4.80911H4.82952H4.85012H4.87091H4.89189H4.91306H4.93441H4.95595H4.97767H4.99957H5.02166H5.04393H5.06638H5.089H5.11181H5.1348H5.15796H5.18129H5.20481H5.22849H5.25235H5.27638H5.30058H5.32495H5.34948H5.37419H5.39906H5.4241H5.44931H5.47467H5.5002H5.52589H5.55175H5.57776H5.60393H5.63026H5.65675H5.68339H5.71019H5.73714H5.76424H5.7915H5.8189H5.84646H5.87417H5.90202H5.93002H5.95817H5.98646H6.0149H6.04348H6.07221H6.10107H6.13007H6.15922H6.1885H6.21792H6.24747H6.27716H6.30699H6.33695H6.36704H6.39726H6.42761H6.4581H6.48871H6.51945H6.55031H6.5813H6.61242H6.64365H6.67502H6.7065H6.7381H6.76983H6.80167H6.83363H6.8657H6.8979H6.9302H6.96262H6.99516H7.0278H7.06056H7.09343H7.1264H7.15948H7.19267H7.22597H7.25937H7.29288H7.32648H7.36019H7.394H7.42792H7.46193H7.49603H7.53024H7.56454H7.59894H7.63343H7.66801H7.70269H7.73746H7.77231H7.80726H7.8423H7.87742H7.91263H7.94792H7.9833H8.01876H8.05431H8.08993H8.12564H8.16143H8.19729H8.23323H8.26925H8.30535H8.34152H8.37776H8.41407H8.45046H8.48692H8.52344H8.56004H8.5967H8.63343H8.67023H8.70709H8.74401H8.781H8.81805H8.85516H8.89233H8.92956H8.96684H9.00419H9.04159H9.07904H9.11655H9.15411H9.19172H9.22939H9.2671H9.30487H9.34268H9.38054H9.41844H9.45639H9.49439H9.53242H9.5705H9.60863H9.64679H9.68499H9.72323H9.7615H9.79981H9.83816H9.87654H9.91496H9.95341H9.99189H10.0304H10.0689H10.1075H10.1461H10.1847H10.2234H10.262H10.3007H10.3395H10.3782H10.417H10.4557H10.4945H10.5334H10.5722H10.611H10.6499H10.6888H10.7277H10.7666H10.8055H10.8444H10.8833H10.9223H10.9612H11.0002H11.0391H11.0781H11.1171H11.156H11.195H11.234H11.2729H11.3119H11.3509H11.3898H11.4288H11.4677H11.5067H11.5456H11.5845H11.6234H11.6623H11.7012H11.7401H11.779H11.8178H11.8567H11.8955H11.9343H11.9731H12.0118H12.0506H12.0893H12.128H12.1667H12.2053H12.2439H12.2825H12.3211H12.3597H12.3982H12.4366H12.4751H12.5135H12.5519H12.5903H12.6286H12.6669H12.7051H12.7433H12.7815H12.8196H12.8577H12.8957H12.9337H12.9717H13.0096H13.0475H13.0853H13.123H13.1608H13.1984H13.2361H13.2736H13.3111H13.3486H13.386H13.4234H13.4607H13.4979H13.5351H13.5722H13.6092H13.6462H13.6832H13.72H13.7568H13.7936H13.8303H13.8669H13.9034H13.9399H13.9763H14.0126H14.0488H14.085H14.1211H14.1571H14.1931H14.229H14.2648H14.3005H14.3361H14.3717H14.4071H14.4425H14.4778H14.5131H14.5482H14.5832H14.6182H14.6531H14.6878H14.7225H14.7571H14.7916H14.826H14.8604H14.8946H14.9287H14.9627H14.9966H15.0305H15.0642H15.0978H15.1313H15.1647H15.198H15.2312H15.2643H15.2973H15.3302H15.363H15.3956H15.4282H15.4606H15.4929H15.5252H15.5572H15.5892H15.6211H15.6528H15.6844H15.7159H15.7473H15.7786H15.8097H15.8407H15.8716H15.9023H15.933H15.9635H15.9938H16.0241H16.0542H16.0842H16.114H16.1437H16.1733H16.2027H16.232H16.2612H16.2902H16.3191H16.3478H16.3764H16.4049H16.4332H16.4614H16.4894H16.5172H16.545H16.5725H16.6H16.6273H16.6544H16.6813H16.7082H16.7348H16.7613H16.7877H16.8139H16.8399H16.8658H16.8915H16.917H16.9424H16.9677H16.9927H17.0176H17.0423H17.0669H17.0913H17.1155H17.1396H17.1634H17.1871H17.2107H17.234H17.2572H17.2802H17.3031H17.3257H17.3482H17.3705H17.3926H17.4145H17.4363H17.4578H17.4792H17.5004H17.5214H17.5422H17.5628H17.5833H17.6035H17.6235H17.6434H17.6631H17.6825H17.7018H17.7209H17.7398H17.7584H17.7769H17.7952H17.8133H17.8311H17.8488H17.8663H17.8835H17.9006H17.9174H17.9341H17.9505H17.9667H17.9827H17.9985H18.0141H18.0294H18.0446H18.0595H18.0742H18.0887H18.103H18.1171H18.1309H18.1445H18.1579H18.171H18.184H18.1967H18.2092H18.2214H18.2334H18.2452H18.2568H18.2681H18.2792H18.2901H18.3007H18.3111H18.3213H18.3312H18.3409H18.3503H18.3595H18.3684H18.3772H18.3856H18.3938H18.4018H18.4095H18.417H18.4243H18.4312H18.438H18.4444H18.4507H18.4566H18.4624H18.4678H18.473H18.478H18.4827H18.4871H18.4912H18.4952H18.4988H18.5022H18.5053H18.5081H18.5107H18.513H18.5151H18.5169H18.5184H18.5196H18.5206H18.5212H18.5217C18.5218 5 18.5218 5 18.5218 4V5C19.0741 5 19.5218 4.55228 19.5218 4C19.5218 3.44772 19.0741 3 18.5218 3V4C18.5218 3 18.5218 3 18.5217 3H18.5212H18.5206H18.5196H18.5184H18.5169H18.5151H18.513H18.5107H18.5081H18.5053H18.5022H18.4988H18.4952H18.4912H18.4871H18.4827H18.478H18.473H18.4678H18.4624H18.4566H18.4507H18.4444H18.438H18.4312H18.4243H18.417H18.4095H18.4018H18.3938H18.3856H18.3772H18.3684H18.3595H18.3503H18.3409H18.3312H18.3213H18.3111H18.3007H18.2901H18.2792H18.2681H18.2568H18.2452H18.2334H18.2214H18.2092H18.1967H18.184H18.171H18.1579H18.1445H18.1309H18.1171H18.103H18.0887H18.0742H18.0595H18.0446H18.0294H18.0141H17.9985H17.9827H17.9667H17.9505H17.9341H17.9174H17.9006H17.8835H17.8663H17.8488H17.8311H17.8133H17.7952H17.7769H17.7584H17.7398H17.7209H17.7018H17.6825H17.6631H17.6434H17.6235H17.6035H17.5833H17.5628H17.5422H17.5214H17.5004H17.4792H17.4578H17.4363H17.4145H17.3926H17.3705H17.3482H17.3257H17.3031H17.2802H17.2572H17.234H17.2107H17.1871H17.1634H17.1396H17.1155H17.0913H17.0669H17.0423H17.0176H16.9927H16.9677H16.9424H16.917H16.8915H16.8658H16.8399H16.8139H16.7877H16.7613H16.7348H16.7082H16.6813H16.6544H16.6273H16.6H16.5725H16.545H16.5172H16.4894H16.4614H16.4332H16.4049H16.3764H16.3478H16.3191H16.2902H16.2612H16.232H16.2027H16.1733H16.1437H16.114H16.0842H16.0542H16.0241H15.9938H15.9635H15.933H15.9023H15.8716H15.8407H15.8097H15.7786H15.7473H15.7159H15.6844H15.6528H15.6211H15.5892H15.5572H15.5252H15.4929H15.4606H15.4282H15.3956H15.363H15.3302H15.2973H15.2643H15.2312H15.198H15.1647H15.1313H15.0978H15.0642H15.0305H14.9966H14.9627H14.9287H14.8946H14.8604H14.826H14.7916H14.7571H14.7225H14.6878H14.6531H14.6182H14.5832H14.5482H14.5131H14.4778H14.4425H14.4071H14.3717H14.3361H14.3005H14.2648H14.229H14.1931H14.1571H14.1211H14.085H14.0488H14.0126H13.9763H13.9399H13.9034H13.8669H13.8303H13.7936H13.7568H13.72H13.6832H13.6462H13.6092H13.5722H13.5351H13.4979H13.4607H13.4234H13.386H13.3486H13.3111H13.2736H13.2361H13.1984H13.1608H13.123H13.0853H13.0475H13.0096H12.9717H12.9337H12.8957H12.8577H12.8196H12.7815H12.7433H12.7051H12.6669H12.6286H12.5903H12.5519H12.5135H12.4751H12.4366H12.3982H12.3597H12.3211H12.2825H12.2439H12.2053H12.1667H12.128H12.0893H12.0506H12.0118H11.9731H11.9343H11.8955H11.8567H11.8178H11.779H11.7401H11.7012H11.6623H11.6234H11.5845H11.5456H11.5067H11.4677H11.4288H11.3898H11.3509H11.3119H11.2729H11.234H11.195H11.156H11.1171H11.0781H11.0391H11.0002H10.9612H10.9223H10.8833H10.8444H10.8055H10.7666H10.7277H10.6888H10.6499H10.611H10.5722H10.5334H10.4945H10.4557H10.417H10.3782H10.3395H10.3007H10.262H10.2234H10.1847H10.1461H10.1075H10.0689H10.0304H9.99189H9.95341H9.91496H9.87654H9.83816H9.79981H9.7615H9.72323H9.68499H9.64679H9.60863H9.5705H9.53242H9.49439H9.45639H9.41844H9.38054H9.34268H9.30487H9.2671H9.22939H9.19172H9.15411H9.11655H9.07904H9.04159H9.00419H8.96684H8.92956H8.89233H8.85516H8.81805H8.781H8.74401H8.70709H8.67023H8.63343H8.5967H8.56004H8.52344H8.48692H8.45046H8.41407H8.37776H8.34152H8.30535H8.26925H8.23323H8.19729H8.16143H8.12564H8.08993H8.05431H8.01876H7.9833H7.94792H7.91263H7.87742H7.8423H7.80726H7.77231H7.73746H7.70269H7.66801H7.63343H7.59894H7.56454H7.53024H7.49603H7.46193H7.42792H7.394H7.36019H7.32648H7.29288H7.25937H7.22597H7.19267H7.15948H7.1264H7.09343H7.06056H7.0278H6.99516H6.96262H6.9302H6.8979H6.8657H6.83363H6.80167H6.76983H6.7381H6.7065H6.67502H6.64365H6.61242H6.5813H6.55031H6.51945H6.48871H6.4581H6.42761H6.39726H6.36704H6.33695H6.30699H6.27716H6.24747H6.21792H6.1885H6.15922H6.13007H6.10107H6.07221H6.04348H6.0149H5.98646H5.95817H5.93002H5.90202H5.87417H5.84646H5.8189H5.7915H5.76424H5.73714H5.71019H5.68339H5.65675H5.63026H5.60393H5.57776H5.55175H5.52589H5.5002H5.47467H5.44931H5.4241H5.39906H5.37419H5.34948H5.32495H5.30058H5.27638H5.25235H5.22849H5.20481H5.18129H5.15796H5.1348H5.11181H5.089H5.06638H5.04393H5.02166H4.99957H4.97767H4.95595H4.93441H4.91306H4.89189H4.87091H4.85012H4.82952H4.80911H4.7889H4.76887H4.74904H4.7294H4.70995H4.6907H4.67165H4.6528H4.63415H4.61569H4.59744H4.57939H4.56154H4.5439H4.52646H4.50923H4.49221H4.47539H4.45878H4.44238H4.42619H4.41022H4.39445H4.37891H4.36357H4.34845H4.33355H4.31887H4.3044H4.29015H4.27613H4.26233H4.24874H4.23539H4.22225C2.80765 3 1.91931 3.57179 1.43872 4.31323C1.21805 4.65367 1.11064 4.98856 1.05734 5.2352C1.03038 5.35996 1.01618 5.46711 1.00865 5.54836C1.00487 5.58916 1.00272 5.62397 1.00152 5.6518C1.00091 5.66573 1.00054 5.67797 1.00033 5.6884L1.0001 5.70269L1.00005 5.7088L1.00004 5.7116L1.00004 5.71293C1.00004 5.71352 1.00004 5.71411 1.76461 5.71426L1.00004 5.71416Z"
        fill="currentColor"
      />
    </>
  ),
})

export const SensitiveIcon = createIcon({
  displayName: 'SensitiveIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
})

export const EmailIcon = createIcon({
  displayName: 'EmailIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 6L12 13L2 6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
})

export const TollIcon = createIcon({
  displayName: 'TollIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <mask
        id="mask0_507_10770"
        style={{maskType: 'alpha'}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="black" />
      </mask>
      <g mask="url(#mask0_507_10770)">
        <path
          d="M15 19.9999C12.7667 19.9999 10.875 19.2249 9.325 17.6749C7.775 16.1249 7 14.2332 7 11.9999C7 9.76653 7.775 7.87486 9.325 6.32486C10.875 4.77486 12.7667 3.99986 15 3.99986C17.2333 3.99986 19.125 4.77486 20.675 6.32486C22.225 7.87486 23 9.76653 23 11.9999C23 14.2332 22.225 16.1249 20.675 17.6749C19.125 19.2249 17.2333 19.9999 15 19.9999ZM7 19.7499C5.23333 19.2832 3.79167 18.3332 2.675 16.8999C1.55833 15.4665 1 13.8332 1 11.9999C1 10.1665 1.55833 8.5332 2.675 7.09986C3.79167 5.66653 5.23333 4.71653 7 4.24986V6.34986C5.8 6.76653 4.83333 7.49153 4.1 8.52486C3.36667 9.5582 3 10.7165 3 11.9999C3 13.2832 3.36667 14.4415 4.1 15.4749C4.83333 16.5082 5.8 17.2332 7 17.6499V19.7499ZM15 17.9999C16.6667 17.9999 18.0833 17.4165 19.25 16.2499C20.4167 15.0832 21 13.6665 21 11.9999C21 10.3332 20.4167 8.91653 19.25 7.74986C18.0833 6.5832 16.6667 5.99986 15 5.99986C13.3333 5.99986 11.9167 6.5832 10.75 7.74986C9.58333 8.91653 9 10.3332 9 11.9999C9 13.6665 9.58333 15.0832 10.75 16.2499C11.9167 17.4165 13.3333 17.9999 15 17.9999Z"
          fill="currentColor"
        />
      </g>
    </>
  ),
})

export const CheckIcon = createIcon({
  displayName: 'CheckIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M8.79508 15.8749L4.62508 11.7049L3.20508 13.1149L8.79508 18.7049L20.7951 6.70492L19.3851 5.29492L8.79508 15.8749Z"
      fill="currentColor"
    />
  ),
})

export const CrossIcon = createIcon({
  displayName: 'CrossIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
      fill="currentColor"
    />
  ),
})

export const ExclamationIcon = createIcon({
  displayName: 'ExclamationIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21Z"
        fill="currentColor"
      />
      <path d="M10 3H14V15H10V3Z" fill="currentColor" />
    </>
  ),
})
